<ng-container>
  <tr class="key-value-row">
    <td class="key-value-row__key">{{ label }}</td>
    <td class="key-value-row__value">
      {{ currentValue }}
    </td>
  </tr>

  @if (hasHistory) {
    <tr>
      <td colspan="2">
        <mat-expansion-panel #panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'Annex.History' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>

          @for (entry of history; track entry.annexId ?? 'original') {
            @if (entry.isOriginal) {
              <div>
                {{ 'Annex.OriginalFromDate' | translate }}
                {{ entry.conclusionDate | date: 'dd.MM.yyyy' }} -
                {{ 'Annex.AgreementEffectiveFrom' | translate }}
                {{ entry.startDate | date: 'dd.MM.yyyy' }} -
                {{ entry.value }}
              </div>
            } @else {
              <div (click)="onAnnexClick($event, entry)" style="cursor: pointer; text-decoration: underline">
                {{ 'Annex.AnnexFromDate' | translate }}
                {{ entry.conclusionDate | date: 'dd.MM.yyyy' }} -
                {{ 'Annex.EffectiveFrom' | translate }}
                {{ entry.startDate | date: 'dd.MM.yyyy' }} -
                {{ entry.value }}
                @if (entry.isCurrent) {
                  <strong>({{ 'Annex.Current' | translate }})</strong>
                }
              </div>
            }
          }
        </mat-expansion-panel>
      </td>
    </tr>
  }
</ng-container>
